import styles from './Footer.module.css'
import Floor from "../Floor/Floor";

type FooterProps = {
    policy?: boolean,
    compact?: boolean
}
const Footer = (props : FooterProps) => {
    const {policy = true, compact = false} = props
    return (
        <div className={`${styles.wrapper} ${compact ? styles.compact : ''}`}>
            <div className={styles.content}>
                {!compact && (
                    <>
                        <h1>Контакты</h1>
                        <div className={styles.info}>
                            <p>Реквизиты компании</p>
                            <p><img src={"/email_icon.svg"} alt={"email"}/> help@cybertech-it.ru</p>
                        </div>
                        <div className={styles.infoBlocks}>
                            <div className={styles.block}>
                                <div className={styles.item}>
                                    <p className={styles.title}>Юридический адрес:</p>
                                    <p>123122, г. Москва, Пресненская набережная, д.12, <br/> пом. 15Н/29</p>
                                </div>
                                <div className={styles.item}>
                                    <p className={styles.title}>Полное наименование: </p>
                                    <p>Общество с ограниченной ответственностью «Сайбертех»</p>
                                </div>
                                <div className={styles.item}>
                                    <p className={styles.title}>Сокращенное наименование: </p>
                                    <p>ООО «Сайбертех»</p>
                                </div>
                                <div className={styles.item}>
                                    <p className={styles.title}>Основной код ОКВЭД: </p>
                                    <p>62.01</p>
                                </div>
                            </div>
                            <div className={styles.block}>
                                <div className={styles.item}>
                                    <p className={styles.title}>Почтовый адрес:</p>
                                    <p>123122, г. Москва, Пресненская набережная, д.12, пом. 15Н/29</p>
                                </div>
                                <div className={styles.item}>
                                    <p className={styles.title}>ИНН/КПП:</p>
                                    <p>9703155452/770301001</p>
                                </div>
                                {policy &&
                                    <div className={styles.item}>
                                        <p className={styles.title}>Расчетный счет:</p>
                                        <p>40702810940000019190</p>
                                    </div>
                                }
                             <div className={styles.item}>
                                    <p className={styles.title}>Коды деятельности:</p>
                                    <p>1.01, 1.02, 1.03, 1.05, 5.01</p>
                                </div>
                            </div>
                            {policy &&
                                <div className={styles.block}>
                                    <div className={styles.item}>
                                        <p className={styles.title}>БИК:</p>
                                        <p>044525225</p>
                                    </div>
                                    <div className={styles.item}>
                                        <p className={styles.title}>К/С:</p>
                                        <p>30101810400000000225</p>
                                    </div>
                                    <div className={styles.item}>
                                        <p className={styles.title}>Наименование банка:</p>
                                        <p>ПАО СБЕРБАНК</p>
                                    </div>
                                    <div className={styles.item}></div>
                                </div>
                            }
                        </div>
                    </>
                )}
                {compact && <Floor whiteLinks/>}
                <div className={styles.footer}>
                    <p style={{fontSize: '10px'}}><span style={{fontWeight: '700'}}>1</span> Исключительные права на Программный продукт принадлежат ООО "Сайбертех" на основании: Свидетельство о государственной регистрации программы для ЭВМ №2024612250, дата государственной регистрации в реестре программ для ЭВМ 30 января 2024 года. Право использования предоставляется по подписке</p>
                   
                </div>
                <div className={styles.footer} style={{ marginBottom: '8px'}}>
                    <p style={{fontSize: '10px'}}><span style={{fontWeight: '700'}}>2</span> Минимальная цена за час разработки составляет 3 300 рублей</p>
                   
                </div>
                <div className={styles.footer}>
                    <p>Copyright 2023-{new Date().getFullYear()}</p>
                   
                </div>
            </div>
        </div>
    )
}

export default Footer;